import React, { useState } from "react";
import share from "../myimgs/Share_new.png";
import {
  FaWhatsapp,
  FaEnvelope,
  FaFacebook,
  FaLinkedin,
  FaCopy,
  FaTimes,
} from "react-icons/fa";

export default function ShareDialog() {
  const [open, setOpen] = useState(false);

  // ⭐ Browser ka current URL
  const fixedUrl =
    typeof window !== "undefined" ? window.location.href : "";

  const shareMessage = `Check out this property:\n${fixedUrl}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(fixedUrl);
    alert("Link copied!");
  };

  // Facebook Share
  const shareFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      fixedUrl
    )}`;
    window.open(url, "_blank");
  };

  // LinkedIn Share
  const shareLinkedIn = () => {
    const url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      fixedUrl
    )}&title=Property&summary=${encodeURIComponent(shareMessage)}`;
    window.open(url, "_blank");
  };

  // Email Share
  const shareEmail = () => {
    const url = `mailto:?subject=Property Link&body=${encodeURIComponent(
      shareMessage
    )}`;
    window.location.href = url;
  };

  return (
    <>
      <button className="direction" onClick={() => setOpen(true)}>
        <img src={share} alt="" /> Share
      </button>

      {open && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "300px",
              padding: "20px",
              borderRadius: "16px",
              textAlign: "center",
              position: "relative",
            }}
          >
            <FaTimes
              onClick={() => setOpen(false)}
              style={{
                position: "absolute",
                right: "12px",
                top: "12px",
                cursor: "pointer",
                fontSize: "18px",
              }}
            />

            <h3>Share Property</h3>
            <p style={{ fontSize: "14px", marginBottom: "10px" }}>
              {fixedUrl}
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              {/* WhatsApp */}
              <a
                href={`https://wa.me/?text=${encodeURIComponent(shareMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp size={30} color="#25D366" />
              </a>

              {/* Email */}
              <span onClick={shareEmail} style={{ cursor: "pointer" }}>
                <FaEnvelope size={30} color="#555" />
              </span>

              {/* Facebook */}
              <span onClick={shareFacebook} style={{ cursor: "pointer" }}>
                <FaFacebook size={30} color="#1877F2" />
              </span>

              {/* LinkedIn */}
              <span onClick={shareLinkedIn} style={{ cursor: "pointer" }}>
                <FaLinkedin size={30} color="#0A66C2" />
              </span>
            </div>

            <button
              onClick={copyToClipboard}
              style={{
                marginTop: "20px",
                width: "100%",
                padding: "10px",
                borderRadius: "10px",
                border: "none",
                background: "#eee",
                cursor: "pointer",
                fontWeight: "600",
                display: "flex",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <FaCopy /> Copy Link
            </button>
          </div>
        </div>
      )}
    </>
  );
}